export default __webpack_public_path__ + "static/media/Devout Shoulders.4b59bb19.jpg";